<template>
  <div class="AppStore">
    <section-header heading="2" ja="アップデート"/>
    <div class="textArea">
      <p>自動で移動しない場合は下記リンクよりアップデートしてください</p>
    </div>
    <div class="storeLink">
      <a href="https://apps.apple.com/jp/app/%E3%83%97%E3%83%AA%E3%82%AF%E3%83%A9on/id1491707486?l=en&amp;itsct=apps_box&amp;itscg=30200" style="display: inline-block; overflow: hidden; border-radius: 13px; width: 160px; height: 71px; padding: 11px; vertical-align: top;"><img src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/ja-JP?size=250x83&amp;releaseDate=1601942400&h=fd01c540f4b59e9b14385d0f0471c6f8" alt="Download on the App Store" style="border-radius: 13px; width: 140px; height: 49px;"></a>
      <a href='https://play.google.com/store/apps/details?id=com.sega.puri&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img alt='Google Play で手に入れよう' src='https://play.google.com/intl/en_us/badges/static/images/badges/ja_badge_web_generic.png' style="height: 70px;" /></a>
    </div>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"

export default {
  name: "AppStore",
  components: {
    SectionHeader
  },
  mounted() {
    location.href="https://app.adjust.com/cawe8dk";
  }
}
</script>

<style lang="scss" scoped>
.textArea {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
  p {
    margin-top: 1em;
  }
}
.storeLink {
  margin: 10px 0;
  text-align: center;
}
</style>
